import { render } from "./footer.vue?vue&type=template&id=05119730&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=05119730&scoped=true&lang=less"

import exportComponent from "/root/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05119730"]])

export default __exports__